import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import { Vnode } from 'mithril';

export default class QRCodeWidget extends Component {
  oninit(vnode: Vnode) {
    super.oninit(vnode);
  }

  view() {
    // debugger
    // return m(".QRCodeWidget", [
    //   m("img", { src: "https://ask.layaair.com/static/css/default/img/cooperate.jpg" })
    // ])
    return m(".Cooperate", [
      m(".Cooperate-title", [
        app.translator.trans('laya-auth.forum.cooperate.title')
      ]),
      m("img.Cooperate-img", { src: app.forum.attribute('baseUrl') + "/images/cooperate.jpg" })
    ])
  }
}
